"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 }
};
//# sourceMappingURL=formItemLayout.js.map